import buyServices from "../API/BuyService";
import { AppDispatch } from "../App/store";
import { deleteSuccessData, fetchBuyData, fetchFailBuyData, getReviewSuccess, postSuccessReview, startBuyDataFetch } from "../Slice/Buy.Slice";

export const GetBuyOrders = (memberid: number) => async (dispatch: AppDispatch) => {

  try {
    dispatch(startBuyDataFetch());
    const response = await buyServices.getBuyOrders(memberid);
    dispatch(fetchBuyData(response));
  } catch (error) {
    console.log('Error in the Buy Orders', error);
    dispatch(fetchFailBuyData());
  }
};

export const postReview = (payload: any) => async (dispatch: AppDispatch) => {
  try {
    
    const response = await buyServices.postReview(payload)
    

    dispatch(postSuccessReview(response))

    if (response) {
      return true
    }
    else {
      return false
    }
  }
  catch (error) {
    console.log('Error in the review ', error);

  }
}

export const GetReview = (itemid: number) => async (dispatch: AppDispatch) => {
  try {

    const response = await buyServices.getReview(itemid)
    const data = JSON.parse(response.data)
    dispatch(getReviewSuccess(data))
  }
  catch (error) {
    console.log('Error in the getreview ', error)
  }
}

export const DeleteCart = (productid: number, memberId: number) => async (dispatch: AppDispatch) => {
  try {

    const response = await buyServices.deleteCart(productid, memberId)
    const dataValue = JSON.parse(response.data)


    dispatch(deleteSuccessData(dataValue))
    if (response) {
      return true
    }
    return false

  }
  catch (error) {
    console.log('Error in the Delete Cart', error)
  }
}


